import Lookup from 'src/componentes/select2';

const PeriodoPorPeriodicidadeRangeLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricaoPeriodo"
    valueKey="periodo"
    url="/PeriodoPorPeriodicidadeRangeLookup"
    {...rest}
  />
);

export default PeriodoPorPeriodicidadeRangeLookup;

